// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as AuthHeaderV2ModuleScss from "../../styles/AuthHeaderV2.module.scss";

var styles = AuthHeaderV2ModuleScss;

function AuthHeaderCmpV2(Props) {
  var close_modal = Props.close_modal;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match.category;
  return React.createElement("div", {
              className: styles.header
            }, React.createElement("div", {
                  className: styles["back-icon"],
                  onClick: (function (param) {
                      PublishEventsHelper$PorterinFeature.publishEvents(category, AuthStore$PorterinFeature.Header.ga_login_modal_close, undefined);
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: AuthVm$PorterinFeature.left_arrow.src,
                      height: AuthVm$PorterinFeature.left_arrow.height,
                      width: AuthVm$PorterinFeature.left_arrow.width,
                      quality: 100.0,
                      alt: AuthVm$PorterinFeature.left_arrow.alt
                    })));
}

var make = AuthHeaderCmpV2;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
